import { render, staticRenderFns } from "./tip-box.vue?vue&type=template&id=c5a31bc8&scoped=true"
import script from "./tip-box.vue?vue&type=script&lang=js"
export * from "./tip-box.vue?vue&type=script&lang=js"
import style0 from "./tip-box.vue?vue&type=style&index=0&id=c5a31bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a31bc8",
  null
  
)

export default component.exports